import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const ITEM_SCHEMA = [
  { key: "text", label: "Message Text", type: "string" as const },
  { key: "code", label: "Coupon Code (optional)", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "announcement-bar",
  label: "Announcement Bar",
  description: "Full-width scrolling ticker bar for promotions and announcements.",
  supportedPages: [
    "home", "shop", "product", "category", "categories", "cart", "checkout",
    "contact", "wishlist",
  ],
  variants: [
    {
      id: "v1",
      label: "V1 — Scrolling Marquee",
      fields: [
        { key: "items", label: "Announcement Items", type: "array", itemSchema: ITEM_SCHEMA },
        { key: "bgColor", label: "Background Color", type: "string", default: "#0989FF" },
        { key: "textColor", label: "Text Color", type: "string", default: "#ffffff" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
